// const devUrl = 'https://shu.wiwipu.com'; // 蔬果云正式
// const devUrl = 'https://huo.wiwipu.com'; // 订货云正式
// const devUrl = 'https://sgy.douhuomall.com';// 测试
// const devUrl = 'https://sgydev.douhuomall.com';// 开发
// const devUrl = 'https://pc.justgreen168.com'; // 泰国
// const devUrl = 'https://syycycyps.com'; // 亿承源
// const devUrl = 'https://sps.yszgcq.com'; // 优链云
// const devUrl = 'https://zhanwei.cc'; // 新加坡-展维美菜
// const devUrl = 'https://scm-gs.zhonglunnet.com'; // 中仑供应链
const devUrl = 'http://192.168.254.12';

let serverList = [{
  name: 'shu',
  url: 'https://shu.wiwipu.com', //域名
  ali_url: 'https://new-ali87.oss-cn-hangzhou.aliyuncs.com', //阿里oss域名
  verifyPhone: true, // 是否验证手机号
  projectType: 0
}, {
  name: 'huo', //订货云*
  url: 'https://huo.wiwipu.com',
  ali_url: 'https://dinghuoyun.oss-cn-hangzhou.aliyuncs.com',
  verifyPhone: true,
  projectType: 1
}, {
  name: 'th', //泰国
  url: 'https://pc.justgreen168.com',
  ali_url: 'https://justgreen168.oss-ap-southeast-7.aliyuncs.com',
  verifyPhone: false,
  projectType: 2
}, {
  name: 'ycy', //亿承源*
  url: 'https://syycycyps.com',
  ali_url: 'https://dinghuoyun.oss-cn-hangzhou.aliyuncs.com',
  verifyPhone: true,
  projectType: 3
}, {
  name: 'yly', //优链云
  url: 'https://sps.yszgcq.com',
  ali_url: 'https://youlianyun.oss-cn-guangzhou.aliyuncs.com',
  verifyPhone: true,
  projectType: 4
}, {
  name: 'xjp', //新加坡-展维美菜*
  url: 'https://pc.zhanweimeicai.com',
  ali_url: 'https://zhanweimeicai.oss-ap-southeast-1.aliyuncs.com',
  verifyPhone: false,
  projectType: 5
}, {
  name: 'zlgyl', //中仑供应链
  url: 'https://scm-gs.zhonglunnet.com',
  ali_url: 'https://zhonglunnet-scm-gs.oss-cn-shanghai.aliyuncs.com',
  verifyPhone: true,
  projectType: 6
}]

let defaultPlat = serverList[0];
let config = new Map();
serverList.forEach(item => {
  config.set(item.url, item)
})
if (config.has(devUrl)) {
  defaultPlat = config.get(devUrl);
}
export {
  devUrl,
  config,
  defaultPlat
}



// WEBPACK FOOTER //
// ./src/config.js